export async function fetchNotifyCount(): Promise<NotifyCount> {
  const defaultValue = {
    mention: 0,
    comment: 0,
    like: 0,
    system: 0,
    message: 0
  }
  if (!useAccessToken().value) {
    return defaultValue
  }
  return http
    .get<NotifyCount>('/v1/notify/count')
    .then((res) => {
      if (res.data) {
        return res.data
      } else {
        return defaultValue
      }
    })
    .catch(() => defaultValue)
}
